module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-center",
    attrs: {
      "id": "creating-order",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "backdrop": "static",
      "keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(!!_vm.createOrderError) ? [_c('modal-header')] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.createOrderError === '') ? [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.creatingOrder || _vm.creatingSubscription
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('creatingOrder')))])] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.createOrderError))])], 2)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9facf812!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/creatingOrder/CreatingOrder.vue
// module id = 1374
// module chunks = 1